import { FIND_DRIVER, UPLOAD_DOCUMENT_COMPANY } from "../../routes";
import customAxios from "../../customAxios";
import { IFindUserInformation } from "../../../types/common.interface";
import utils from "../../../utils";
import { IUploadDocumentCompany } from "../../../types/company.interface";

async function uploadCompanyDocument(props: IUploadDocumentCompany) {
  var thisUrl = UPLOAD_DOCUMENT_COMPANY;

  let body: any = {
    companyLicence: props.companyLicence ? props.companyLicence : "",
    nationalCardBack: props.nationalCardBack ? props.nationalCardBack : "",
    nationalCardFront: props.nationalCardFront ? props.nationalCardFront : "",
  };

  // ?? ---------------------------------------------------------------------------------------------------------------------
  // ?? =====================================================================================================================
  // ??                                                    Filtering For SuperAgent
  // ?? =====================================================================================================================
  // ?? ---------------------------------------------------------------------------------------------------------------------

  // if (city) query({ target: "city", value: city?._id });
  // if (company) query({ target: "company", value: company?._id });
  // if (marital) query({ target: "marital", value: marital?.value });
  // if (gender) query({ target: "gender", value: gender?.value });

  try {
    return (await customAxios.put(thisUrl + "/" + props._id, body)).data;
  } catch (error: any) {
    console.error({ FIND_DRIVER: error });
  }
}

export default uploadCompanyDocument;
